/* HONEY MONEY · comportamiento del tema (P23). Copia de la demo aprobada (shop.js + template.html, P22) sobre el HTML real de Shopify.
   Capas (menú, hoja de tallas, cajón) con velo, foco atrapado, Esc y Atrás; tarjetas que reaccionan al ratón; galería; acordeones;
   tallas; barra fija; compartir; volver; orden y "Cargar más". El carrito (AJAX) vive en hm-cart.js y usa window.HM de aquí.
   Las páginas cambian con una carga normal (instantánea), sin transiciones: Max. */
(() => {
if (window.HM) return; // la cabecera lo carga también en las páginas con el layout de Dawn
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const RM = matchMedia('(prefers-reduced-motion:reduce)');
const SMOOTH = () => RM.matches ? 'auto' : 'smooth';
const CFG = window.hmCfg || {s: {}};
const S = k => (CFG.s && CFG.s[k]) || '';
const HM = window.HM = {$, $$, RM, S};

/* ================= CAPAS ================= */
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
const LAYERS = '.hm-sheet.on, .hm-drawer.on, .hm-mnav.on';
const layerEl = () => $(LAYERS);
let lastFocus = null, layerPushed = false, popTimer = 0, ignorePop = false;
const scrim = () => $('#hm-scrim');
const closeAll = keepHistory => {
  const had = layerEl();
  $$(LAYERS).forEach(x => x.classList.remove('on')); if (scrim()) scrim().classList.remove('on'); document.body.classList.remove('hm-lock');
  if (had && lastFocus && document.contains(lastFocus)) lastFocus.focus({preventScroll: true});
  lastFocus = null;
  if (keepHistory === true) { clearTimeout(popTimer); layerPushed = false; }
  else if (layerPushed) { clearTimeout(popTimer); popTimer = setTimeout(() => { if (layerPushed && !layerEl()) { layerPushed = false; ignorePop = true; history.back(); } }, 0); }
};
const open = el => {
  if (!el) return;
  if (!layerEl()) lastFocus = document.activeElement;
  if (!layerPushed) { try { history.pushState({hmLayer: 1}, '', location.href); layerPushed = true; } catch (e) {} } // Atrás del móvil cierra la capa
  $$(LAYERS).forEach(x => x !== el && x.classList.remove('on'));
  el.classList.add('on'); if (scrim()) scrim().classList.add('on'); document.body.classList.add('hm-lock');
  el.setAttribute('tabindex', '-1');
  setTimeout(() => { if (el.classList.contains('on')) (el.querySelector(FOCUSABLE) || el).focus({preventScroll: true}); }, 40);
};
HM.open = open; HM.closeAll = closeAll; HM.layerEl = layerEl;
addEventListener('popstate', () => {
  if (ignorePop) { ignorePop = false; return; }
  if (layerEl()) { closeAll(true); return; }
  if (history.state && history.state.hmLayer) history.back();
});
document.addEventListener('click', e => {
  if (e.target.id === 'hm-scrim') return closeAll();
  const x = e.target.closest('[data-hm-close]'); if (x) closeAll(x.matches('a[href]')); // un enlace que navega no toca el historial
});
addEventListener('keydown', e => { if (e.key === 'Escape' && layerEl()) closeAll(); });
addEventListener('keydown', e => {
  const L = e.key === 'Tab' && layerEl(); if (!L) return;
  const f = $$(FOCUSABLE, L).filter(x => x.offsetParent !== null), first = f[0], last = f[f.length - 1], cur = document.activeElement;
  if (!first) return;
  if (!L.contains(cur) || (e.shiftKey && cur === first)) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
});
/* volver de la página anterior (bfcache): ninguna capa se queda abierta */
addEventListener('pageshow', e => { if (e.persisted && layerEl()) closeAll(true); });

/* menú del móvil */
document.addEventListener('click', e => { if (e.target.closest('#hm-burger')) open($('#hm-mnav')); });

/* ================= AVISO BREVE, LECTOR Y CELEBRACIÓN ================= */
let toastT = 0;
HM.toast = (msg, act) => {
  const t = $('#hm-toast'); if (!t) return;
  $('#hm-toast-msg').textContent = msg;
  const b = $('#hm-toast-btn'); b.hidden = !act; if (act) { b.textContent = act.label; b.onclick = () => { t.classList.remove('on'); act.fn(); }; }
  t.classList.toggle('hm-toast--top', !!$('.hm-drawer.on')); t.classList.add('on');
  clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 3600);
};
HM.say = msg => { const r = $('#hm-sr'); if (!r) return; r.textContent = ''; setTimeout(() => { r.textContent = msg; }, 30); };
const CHK = '<svg class="hm-chk" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
const burst = el => {
  if (RM.matches) return;
  let box = $('#hm-sparks'); if (!box) { box = document.createElement('div'); box.id = 'hm-sparks'; document.body.appendChild(box); }
  const r = el.getBoundingClientRect(), n = 10, spread = Math.min(r.width / 2, 56);
  for (let i = 0; i < n; i++) {
    const d = document.createElement('i'), a = (i / n) * 2 * Math.PI + Math.random() * .6, dist = 38 + Math.random() * 38, sz = 6 + Math.random() * 5, ox = (Math.random() - .5) * spread, dx = Math.cos(a) * dist, dy = Math.sin(a) * dist;
    const at = k => `translate(calc(-50% + ${(dx * k).toFixed(1)}px), calc(-50% + ${(dy * k).toFixed(1)}px))`;
    d.className = 'hm-spark'; d.style.cssText = `left:${r.left + r.width / 2 + ox}px;top:${r.top + r.height / 2}px;width:${sz}px;height:${sz}px;background:${i % 3 ? 'var(--gold)' : 'var(--gold2)'}`; box.appendChild(d);
    d.animate([{transform: at(0) + ' scale(1)', opacity: 1, offset: 0}, {transform: at(.8) + ' scale(.9)', opacity: 1, offset: .55}, {transform: at(1) + ' scale(.2)', opacity: 0, offset: 1}], {duration: 940 + Math.random() * 390, easing: 'cubic-bezier(.2,.8,.3,1)'}).onfinish = () => d.remove();
  }
};
/* el propio botón celebra: pulsación, chispas doradas y check + "Añadido" ~1 s; con "reducir movimiento" solo cambia la etiqueta */
HM.celebrate = btn => {
  if (!btn || !btn.isConnected) return;
  const inner = btn.classList.contains('hm-q') ? btn.querySelector('span') : btn, size = btn.matches('.hm-sizes button, .hm-q');
  burst(btn);
  if (!RM.matches) { inner.classList.remove('hm-cel'); void inner.offsetWidth; inner.classList.add('hm-cel'); }
  if (btn._orig === undefined) { btn._orig = inner.innerHTML; btn._minW = btn.style.minWidth; btn.style.minWidth = btn.offsetWidth + 'px'; }
  inner.innerHTML = size ? CHK : CHK + (S('addedBtn') || '');
  clearTimeout(btn._celT); btn._celT = setTimeout(() => { if (!btn.isConnected) return; inner.innerHTML = btn._orig; btn.style.minWidth = btn._minW; delete btn._orig; }, 1300);
};

/* ================= HOJA DE TALLAS (añadido rápido desde la tarjeta) ================= */
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
HM.esc = esc;
HM.openSheet = (q, ctx) => {
  const vars = JSON.parse(q.dataset.vars || '[]');
  $('#hm-sheet-body').innerHTML = `<div class="hm-qs" data-ctx="${ctx || 'grid'}">
    <h2 class="hm-d">${esc(q.dataset.title)}</h2><div class="hm-qs__p">${q.dataset.from ? esc(q.dataset.from) + ' ' : ''}<span class="hm-m">${esc(q.dataset.price)}</span></div>
    <h4>${esc(S('pickSize'))}</h4>
    <div class="hm-sizes">${vars.map(v => `<button type="button" data-act="pick" data-t="sheet-size" data-v="${v.id}" data-size="${esc(v.t)}"${v.a ? '' : ` aria-disabled="true" aria-label="${esc(v.t)}, agotada"`}>${esc(v.t)}</button>`).join('')}</div>
    <a class="hm-qs__more" href="${esc(q.dataset.url)}" data-hm-close>${esc(S('full'))}</a></div>`;
  open($('#hm-sheet'));
};

/* "Avísame cuando vuelva" desde una tarjeta agotada: la hoja lleva el formulario de cliente de Shopify que la tarjeta trae dentro de un <template> */
document.addEventListener('click', e => {
  const b = e.target.closest('[data-act="notify"]'); if (!b) return;
  const tpl = $('template[data-notify]', b.closest('.hm-lbuy')); if (!tpl) return;
  const body = $('#hm-sheet-body'); body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true)); open($('#hm-sheet'));
});

/* ================= TARJETAS ================= */
/* fotos extra del carrusel: solo en táctil y solo cuando alguien toca la tarjeta */
const hydrate = m => $$('img[data-src]', m).forEach(i => { i.srcset = i.dataset.srcset; i.src = i.dataset.src; i.removeAttribute('data-src'); i.removeAttribute('data-srcset'); });
document.addEventListener('touchstart', e => { const m = e.target.closest && e.target.closest('.hm-card__m'); if (m) hydrate(m); }, {passive: true});
/* sin cajas vacías: el azulejo brilla suave hasta que llega la primera foto; foto rota = el nombre del producto */
const ldMark = img => { const m = img.closest('.hm-card__m, .hm-gal__main'); if (m) m.classList.add('ld'); };
document.addEventListener('load', e => { if (e.target.tagName === 'IMG') ldMark(e.target); }, true);
document.addEventListener('error', e => {
  const i = e.target; if (i.tagName !== 'IMG') return;
  const m = i.closest('.hm-card__m, .hm-gal__main');
  if (!m) { i.style.visibility = 'hidden'; return; }
  if (i.alt) { m.classList.add('bad', 'ld'); m.dataset.alt = i.alt.replace(/\s*\([^)]*\d+\)$/, ''); } else i.remove();
}, true);
const ldSweep = () => $$('.hm-card__m img, .hm-gal__main img').forEach(i => { if (i.complete && i.naturalWidth) ldMark(i); });
/* la foto REACCIONA con ratón fino: zoom (.hv), inclinación hacia el puntero (máx. 3 grados) y deriva suave con inercia; con "reducir movimiento" solo el zoom */
const FINE = matchMedia('(hover:hover) and (pointer:fine)');
const tile = e => (e.pointerType === 'touch' || !FINE.matches) ? null : (e.target.closest && e.target.closest('.hm-card__m'));
const FLOAT = new Map(); let floatRaf = 0, floatLast = 0;
const floatTick = t => {
  floatRaf = 0; const dt = Math.min(.1, (t - floatLast) / 1000 || .016), k = 1 - Math.exp(-dt / .3), w = t / 1000, TAU = 2 * Math.PI; floatLast = t;
  for (const [m, st] of FLOAT) {
    st.amp += (st.target - st.amp) * k;
    if (!st.target && st.amp < .002) { ['--fx', '--fy', '--fr'].forEach(v => m.style.removeProperty(v)); FLOAT.delete(m); continue; }
    m.style.setProperty('--fx', (st.amp * 1.5 * Math.sin(w * TAU / 5.2)).toFixed(3) + 'px');
    m.style.setProperty('--fy', (st.amp * 2 * Math.sin(w * TAU / 4.4 + 1.3)).toFixed(3) + 'px');
    m.style.setProperty('--fr', (st.amp * 1.1 * Math.sin(w * TAU / 5.8 + 2.1)).toFixed(3) + 'deg');
  }
  if (FLOAT.size) floatRaf = requestAnimationFrame(floatTick);
};
const floatTo = (m, target) => { const st = FLOAT.get(m) || {amp: 0, target}; st.target = target; FLOAT.set(m, st); if (!floatRaf) { floatLast = performance.now(); floatRaf = requestAnimationFrame(floatTick); } };
let tiltRaf = 0, tiltEv = null;
document.addEventListener('pointerenter', e => { const m = e.target.classList && e.target.classList.contains('hm-card__m') ? tile(e) : null; if (!m) return; m.classList.add('hv'); if (!RM.matches) floatTo(m, 1); }, true);
document.addEventListener('pointermove', e => {
  if (RM.matches) return; const m = tile(e); if (!m) return;
  tiltEv = {m, x: e.clientX, y: e.clientY}; if (tiltRaf) return;
  tiltRaf = requestAnimationFrame(() => { tiltRaf = 0; const {m, x, y} = tiltEv, r = m.getBoundingClientRect();
    const nx = Math.max(-.5, Math.min(.5, (x - r.left) / r.width - .5)), ny = Math.max(-.5, Math.min(.5, (y - r.top) / r.height - .5));
    m.style.setProperty('--ry', (nx * 6).toFixed(2) + 'deg'); m.style.setProperty('--rx', (-ny * 6).toFixed(2) + 'deg'); });
}, {passive: true});
document.addEventListener('pointerleave', e => { const m = e.target.classList && e.target.classList.contains('hm-card__m') ? tile(e) : null; if (!m) return; m.classList.remove('hv'); m.style.removeProperty('--rx'); m.style.removeProperty('--ry'); if (FLOAT.has(m)) floatTo(m, 0); }, true);

/* ================= GALERÍA Y TIRAS DE FOTOS ================= */
const bez = (x1, y1, x2, y2) => t => { let u = t; for (let i = 0; i < 8; i++) { const cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, x = ((ax * u + bx) * u + cx) * u - t, dx = (3 * ax * u + 2 * bx) * u + cx; if (Math.abs(x) < 1e-5 || !dx) break; u -= x / dx; } const cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by; return ((ay * u + by) * u + cy) * u; };
const SITE_EASE = bez(.32, .72, 0, 1);
const slideTo = (m, to) => {
  if (RM.matches) { m.scrollLeft = to; return; }
  const from = m.scrollLeft, d = to - from, T0 = performance.now(), D = 455; if (!d) return;
  m.style.scrollSnapType = 'none'; m.classList.add('moving'); cancelAnimationFrame(m._raf);
  const step = now => { const k = Math.min(1, (now - T0) / D); m.scrollLeft = from + d * SITE_EASE(k); if (k < 1) m._raf = requestAnimationFrame(step); else m.style.scrollSnapType = ''; };
  m._raf = requestAnimationFrame(step);
};
/* en reposo solo se pinta la foto actual, con el scroll clavado en un entero (el canto de la vecina no asoma) */
const settleLater = s => {
  s.classList.add('moving'); clearTimeout(s._st);
  s._st = setTimeout(() => {
    const w = s.clientWidth || 1, i = Math.round(s.scrollLeft / w); if (Math.abs(s.scrollLeft - i * w) > .01 && Math.abs(s.scrollLeft - i * w) < 2) s.scrollLeft = i * w;
    [...s.children].forEach((im, k) => im.classList.toggle('cur', k === i)); s.classList.remove('moving');
  }, 140);
};
/* puntos estilo Instagram: siguen la posición real del scroll */
const dotsPaint = s => { const w = s.clientWidth || 1, p = s.scrollLeft / w; $$('#hm-gdots i').forEach((d, k) => d.style.setProperty('--sc', Math.max(0, 1 - Math.abs(k - p) / 2).toFixed(3))); };
document.addEventListener('scroll', e => {
  const s = e.target; if (!s.classList || !s.clientWidth) return;
  const i = Math.round(s.scrollLeft / s.clientWidth);
  if (s.classList.contains('hm-strip') || s.id === 'hm-gal') settleLater(s);
  if (s.classList.contains('hm-strip')) $$('.hm-dots i', s.closest('.hm-card__m')).forEach((d, k) => d.classList.toggle('on', k === i));
  if (s.id === 'hm-gal') { $$('.hm-gal__t').forEach((t, k) => t.classList.toggle('on', k === i)); dotsPaint(s); }
}, {capture: true, passive: true});

/* ================= FICHA ================= */
const pdpInit = () => {
  const box = $('#hm-pdp'); if (!box) return;
  const vars = () => JSON.parse(box.dataset.vars || '[]'), vid = () => $('#hm-vid'), g = () => $('#hm-gal'); // se leen al usarlos: el formulario puede repintarse
  if (g()) dotsPaint(g());
  const select = id => {
    const v = vars().find(x => String(x.id) === String(id)); if (!v || !vid()) return; vid().value = id;
    $$('.hm-sizes button', box).forEach(x => x.setAttribute('aria-pressed', String(x.dataset.v === String(id))));
    const err = $('#hm-sz-err'); if (err) err.hidden = true;
    const st = $('#hm-stock'); if (st) st.textContent = v.q !== null && v.q <= 3 ? (box.dataset.left || '').replace('[n]', v.q) : '';
    $$('[data-hm-price]').forEach(p => { p.textContent = v.p; }); const pr = $('#hm-price'); if (pr) pr.textContent = v.p;
    try { const u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u); } catch (e) {}
  };
  HM.pdpSelect = select;
  /* pide talla antes de añadir: aviso en rojo y un pequeño temblor */
  HM.pdpNeedSize = () => {
    if (box.dataset.sized !== 'true' || (vid() && vid().value)) return false;
    const s = $('#hm-sz'), err = $('#hm-sz-err'); if (err) err.hidden = false;
    if (s) { s.classList.remove('shake'); void s.offsetWidth; s.classList.add('shake'); s.scrollIntoView({block: 'center', behavior: SMOOTH()}); }
    return true;
  };
  box.addEventListener('click', e => {
    const b = e.target.closest('[data-act]'); if (!b) return;
    const a = b.dataset.act;
    if (a === 'acc') { const item = b.closest('.hm-acc'), willOpen = !item.classList.contains('on'); $$('.hm-acc', box).forEach(x => { x.classList.remove('on'); $('.hm-acc__b', x).setAttribute('aria-expanded', 'false'); }); if (willOpen) { item.classList.add('on'); b.setAttribute('aria-expanded', 'true'); } return; }
    if (a === 'gal') { slideTo(g(), +b.dataset.i * g().clientWidth); return; }
    if (a === 'size') { if (b.getAttribute('aria-disabled') !== 'true') select(b.dataset.v); return; }
    if (a === 'share') {
      const url = location.href.split('?')[0], copy = () => navigator.clipboard ? navigator.clipboard.writeText(url).then(() => HM.toast(S('copied')), () => HM.toast(S('copyFail'))) : HM.toast(S('copyFail'));
      if (navigator.share && matchMedia('(hover:none)').matches) navigator.share({title: b.dataset.title, url}).catch(err => { if (err.name !== 'AbortError') copy(); });
      else copy();
    }
  });
  /* barra fija de compra (móvil): aparece cuando el botón de la ficha ya se ha ido por arriba */
  addEventListener('scroll', () => { const bar = $('#hm-sbar'), add = $('[data-t="add"]', box); if (!bar || !add) return; const on = add.getBoundingClientRect().bottom < 64; bar.classList.toggle('on', on); document.body.classList.toggle('hm-sbar-on', on); }, {passive: true});
};

/* flecha de volver: si la página anterior es de esta tienda, vuelve a ella (con su orden y su posición); si no, el enlace (la colección) */
document.addEventListener('click', e => {
  const c = e.target.closest('[data-hm-back]'); if (!c) return;
  let same = !!HM.hashNav; try { same = same || (!!document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1); } catch (err) {}
  if (same) { e.preventDefault(); history.back(); }
});

/* ================= ARTISTAS: la página de un artista vive en esta dirección (#a-nombre) =================
   La rejilla y la página del artista se alternan con CSS (:target). Aquí solo: título de la pestaña, volver arriba y foco en el nombre; la flecha de volver usa el historial. */
const baseTitle = document.title;
const onHash = () => {
  const d = /^#a-/.test(location.hash) ? document.getElementById(location.hash.slice(1)) : null;
  document.title = d ? (d.dataset.name || '') + ' | ' + baseTitle : baseTitle;
  if (!d) return;
  scrollTo(0, 0);
  const h = $('h1, [role="heading"]', d); if (h) { h.setAttribute('tabindex', '-1'); h.focus({preventScroll: true}); }
};
addEventListener('hashchange', () => { HM.hashNav = true; onHash(); });
if (/^#a-/.test(location.hash)) onHash();

/* ================= AVISOS LEGALES (/policies/*): flecha en la fila del título e índice entre el título y el texto ================= */
const policyInit = () => {
  const title = $('.shopify-policy__title'); if (!title || title.dataset.hmDone) return; title.dataset.hmDone = '1';
  const tpl = $('#hm-policy-crumb'); if (tpl) title.prepend(tpl.content.cloneNode(true));
  const idx = $('.hm-pindex'); if (idx) title.after(idx);
};

/* ================= CUENTA: direcciones (país y provincia, y borrar con confirmación) ================= */
const addressInit = () => {
  const box = $('[data-customer-addresses]'); if (!box) return;
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {hideElement: 'AddressProvinceContainerNew'});
    $$('select[id^="AddressCountry_"]', box).forEach(sel => { const id = sel.id.replace('AddressCountry_', ''); new Shopify.CountryProvinceSelector('AddressCountry_' + id, 'AddressProvince_' + id, {hideElement: 'AddressProvinceContainer_' + id}); });
  }
  box.addEventListener('click', e => {
    const b = e.target.closest('[data-hm-adr-del]'); if (!b) return;
    if (confirm(b.dataset.confirm) && window.Shopify && Shopify.postLink) Shopify.postLink(b.dataset.target, {parameters: {_method: 'delete'}});
  });
};

/* ================= COLECCIÓN: orden y "Cargar más" ================= */
document.addEventListener('change', e => {
  const s = e.target.closest('[data-hm-sort]'); if (!s) return;
  const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
});
let moreBusy = false;
const loadMore = async () => {
  const more = $('#hm-more'), grid = $('#hm-grid'); if (!more || !grid || moreBusy || !more.dataset.next) return;
  moreBusy = true;
  try {
    const r = await fetch(more.dataset.next, {headers: {Accept: 'text/html'}}); if (!r.ok) throw new Error(r.status);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    $$('#hm-grid > .hm-card', doc).forEach(c => grid.appendChild(document.adoptNode(c)));
    const nm = $('#hm-more', doc), n = $$('.hm-card', grid).length, tpl = $('#hm-more-n').dataset.tpl || '';
    $('#hm-more-n').textContent = tpl.replace('[n]', n).replace('[total]', more.dataset.total);
    if (nm && nm.dataset.next) { more.dataset.next = nm.dataset.next; $('#hm-more-btn').href = nm.dataset.next; } else more.remove();
    ldSweep();
  } catch (err) { /* sin JavaScript o con fallo, el botón es un enlace normal a la página siguiente */ }
  moreBusy = false;
};
document.addEventListener('click', e => { if (e.target.closest('#hm-more-btn')) { e.preventDefault(); loadMore(); } });


/* ================= FORMULARIOS DE SHOPIFY (boletín, avísame cuando vuelva, contacto) =================
   Se mandan por fetch y el éxito sale DENTRO del propio bloque, sin recargar ni ventana. Shopify responde con una redirección a ?customer_posted=true
   (o contact_posted=true) si todo fue bien; si lo que vuelve es otra cosa (error, o un desafío anti spam), se manda el formulario de la forma normal
   para que se vea el error o se pueda resolver el desafío. Sin JavaScript el formulario funciona igual. */
document.addEventListener('submit', async e => {
  const f = e.target.closest('form[data-hm-ajax]'); if (!f || f._hmBusy) return;
  e.preventDefault(); f._hmBusy = true;
  const flag = f.dataset.hmAjax, btn = $('button[type="submit"]', f); if (btn) btn.setAttribute('aria-busy', 'true');
  let good = false;
  try {
    const r = await fetch(f.action, {method: 'POST', body: new FormData(f), headers: {'X-Requested-With': 'XMLHttpRequest'}, redirect: 'follow'});
    good = r.ok && (r.url.includes(flag + '=true') || r.url.includes('posted=true'));
  } catch (err) { good = false; }
  if (btn) btn.removeAttribute('aria-busy');
  if (!good) { f._hmBusy = false; f.removeAttribute('data-hm-ajax'); f.requestSubmit ? f.requestSubmit() : f.submit(); return; } // la vía normal enseña el error o el desafío (sin el atributo, el segundo envío ya no pasa por aquí)
  f._hmBusy = false;
  const host = f.closest('[data-hm-formhost]') || f.parentElement; host.classList.add('sent'); f.setAttribute('hidden', '');
  const ok = host.querySelector('.hm-news__ok, .hm-notify__ok, .hm-contact__ok');
  HM.say(ok ? ok.textContent : '');
});

/* ================= ARRANQUE ================= */
const boot = () => {
  pdpInit(); policyInit(); addressInit(); ldSweep();
  new MutationObserver(ldSweep).observe($('#MainContent') || document.body, {childList: true, subtree: true});
  const more = $('#hm-more'); if (more && 'IntersectionObserver' in window) new IntersectionObserver(es => { if (es[0].isIntersecting) loadMore(); }, {rootMargin: '600px 0px'}).observe(more);
  const chips = $('#hm-chips'), a = chips && $('[aria-current]', chips); if (a) chips.scrollLeft = Math.max(0, a.offsetLeft - (chips.clientWidth - a.offsetWidth) / 2); // el chip activo a la vista
};
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
